import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import React, { useEffect, useState, useMemo } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Button,
  Input,
  CardTitle,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import Select from "react-select"
import API from "../../../api"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Flip } from "react-toastify"
import "react-datepicker/dist/react-datepicker.css"
const ViewCandidat = props => {
  const [disbutReg, setDisbutReg] = useState(true)
  const [prenom, setPrenom] = useState("")
  const [nom, setNom] = useState("")
  const [cin, setCin] = useState("")
  const [email, setEmail] = useState("")
  const [telephone, setTelephone] = useState("")
  const [natureLicence, setNatureLicence] = useState([])
  const [selectNatureLicence, setSelectNatureLicence] = useState("")
  const [etablissementOrigine, setEtablissementOrigine] = useState([])
  const [selectEtablissementOrigine, setSelectEtablissementOrigine] =
    useState("")
  const [etablissementName, setEtablissementName] = useState("")
  const [anneeLicence, setAnneeLicence] = useState("")
  const [specilaiteName, setSpecilaiteName] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  const [moyGenAnnee1, setMoyGenAnnee1] = useState("")
  const [sessionLicence1, setSessionLicence1] = useState([])
  const [selectSessionLicence1, setSelectSessionLicence1] = useState("")
  const [credit1, setCredit1] = useState("")
  const [moyGenAnnee2, setMoyGenAnnee2] = useState("")
  const [sessionLicence2, setSessionLicence2] = useState([])
  const [selectSessionLicence2, setSelectSessionLicence2] = useState("")
  const [credit2, setCredit2] = useState("")
  const [moyGenAnnee3, setMoyGenAnnee3] = useState("")
  const [sessionLicence3, setSessionLicence3] = useState([])
  const [selectSessionLicence3, setSelectSessionLicence3] = useState("")
  const [credit3, setCredit3] = useState("")
  const [notePFE, setNotePFE] = useState("")
  const [anneeRedoublement, setAnneeRedoublement] = useState("")
  const [mastere1, setMastere1] = useState([])
  const [selectMastere1, setSelectMastere1] = useState("")
  const [selectMastere2, setSelectMastere2] = useState("")
  const [mastere2, setMastere2] = useState([])
  const [arrayMatiere1, setArrayMatiere1] = useState([])
  const [arrayMatiere2, setArrayMatiere2] = useState([])
  const [choixMatieres1, setChoixMatieres1] = useState({})
  const [choixMatieres2, setChoixMatieres2] = useState({})
  const [notesMatieres1, setNotesMatieres1] = useState({})
  const [notesMatieres2, setNotesMatieres2] = useState({})
  const [id, setId] = useState("")
  const [releveLicence1, setReleveLicence1] = useState(null)
  const [releveLicence2, setReleveLicence2] = useState(null)
  const [releveLicence3, setReleveLicence3] = useState(null)
  const [diplomeLicence, setDiplomeLicence] = useState(null)
  const [photo, setPhoto] = useState(null)
  const [photoUrl, setPhotoUrl] = useState(null)
  const [score, setScore] = useState(0)
  const [score1, setScore1] = useState(0)
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [status, setStatus] = useState([
    { value: 1, label: "En attente" },
    { value: 2, label: "Validée" },
    { value: 3, label: "Admis" },
    { value: 4, label: "Refusée" },
    { value: 5, label: "Sur la liste d'attente" },
  ])
  const [selectStatus, setSelectStatus] = useState("")
  const [etatValide, setEtatValide] = useState(0)
  const [etatValide1, setEtatValide1] = useState(0)
  const [statusName, setStatusName] = useState("")
  const [statusName1, setStatusName1] = useState("")
  const [candidature, setCandidature] = useState("")
  const [candidature1, setCandidature1] = useState("")
  const [etatCandidature, setEtatCandidature] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id

  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var CandidatCin = array[1]
    API.post("master/candidat/get_by_cin", {
      annee_id: annee_id,
      cin: CandidatCin,
    }).then(resMastere => {
      setId(resMastere.data.candidat.id)
      setNom(resMastere.data.candidat.nom_fr)
      setPrenom(resMastere.data.candidat.prenom_fr)
      setCin(resMastere.data.candidat.cin)
      setEmail(resMastere.data.candidat.email)
      setTelephone(resMastere.data.candidat.telephone)
      setSelectNatureLicence(resMastere.data.candidat.nature_licence)
      setSelectEtablissementOrigine(resMastere.data.candidat.etablissement)
      setEtablissementName(resMastere.data.candidat.etablissement_name)
      setAnneeLicence(resMastere.data.candidat.annee_licence)
      setSelectSpecilaite(resMastere.data.candidat.specialite)
      setSpecilaiteName(resMastere.data.candidat.specialite_name)
      setMoyGenAnnee1(resMastere.data.candidat.moyennes_generales.moyenne_gen1)
      setMoyGenAnnee2(resMastere.data.candidat.moyennes_generales.moyenne_gen2)
      setMoyGenAnnee3(resMastere.data.candidat.moyennes_generales.moyenne_gen3)
      setCredit1(resMastere.data.candidat.credits.credit1)
      setCredit2(resMastere.data.candidat.credits.credit2)
      setCredit3(resMastere.data.candidat.credits.credit3)
      setCredit3(resMastere.data.candidat.credits.credit3)
      setSelectSessionLicence1(
        resMastere.data.candidat.sessions_licence.session_licence1
      )
      setSelectSessionLicence2(
        resMastere.data.candidat.sessions_licence.session_licence2
      )
      setSelectSessionLicence3(
        resMastere.data.candidat.sessions_licence.session_licence3
      )
      setNotePFE(resMastere.data.candidat.note_pfe)
      setAnneeRedoublement(resMastere.data.candidat.nb_annees_redoublement)
      setReleveLicence1(resMastere.data.candidat.releve_licence_1 ?? null)
      setReleveLicence2(resMastere.data.candidat.releve_licence_2 ?? null)
      setReleveLicence3(resMastere.data.candidat.releve_licence_3 ?? null)
      setDiplomeLicence(resMastere.data.candidat.diplome_licence ?? null)
      setEtatCandidature(resMastere.data.candidat.etat_candidature ?? null)
      setPhoto(resMastere.data.candidat.photo ?? null)
      setScore(resMastere.data.candidat.candidatures[0].score)
      setEtatValide(resMastere.data.candidat.candidatures[0].statut_id)
      setStatusName(resMastere.data.candidat.candidatures[0].statut_name)
      setCandidature(resMastere.data.candidat.candidatures[0].id)
      if (resMastere.data.candidat.photo != null) {
        API.post(
          "master/candidat/download",
          {
            cin: CandidatCin,
            annee_id: annee_id,
            filename: resMastere.data.candidat.photo,
          },
          { responseType: "blob" }
        )
          .then(resPhoto => {
            if (resPhoto.data instanceof Blob) {
              const blob = resPhoto.data
              const url = window.URL.createObjectURL(blob)
              setPhotoUrl(url)
            } else {
              if (res.data.errNum === 404 || res.data.errNum === "404") {
                toast.error(":no_entry: " + res.data.msg, {
                  containerId: "A",
                })
              } else {
                toast.error("Erreur inconnue lors du chargement de la photo.", {
                  containerId: "A",
                })
              }
            }
          })
          .catch(err => {
            toast.error("Erreur de chargement. Vérifiez votre connexion.", {
              containerId: "A",
            })
          })
      }
      setSelectMastere1(
        resMastere.data.candidat.candidatures[0].specialite_master
      )
      const matieres = resMastere.data.candidat.candidatures[0].matieres
      setArrayMatiere1(matieres)
      const choixInit = {}
      const notesInit = {}
      matieres.forEach(m => {
        if (m.note && m.note !== "" && m.note !== null) {
          choixInit[m.value] = "oui"
          notesInit[m.value] = m.note
        } else {
          choixInit[m.value] = "non"
        }
      })
      setChoixMatieres1(choixInit)
      setNotesMatieres1(notesInit)
      if (resMastere.data.candidat.candidatures[1]) {
        setEtatValide1(resMastere.data.candidat.candidatures[1].statut_id)
        setScore1(resMastere.data.candidat.candidatures[1].score)
        setStatusName1(resMastere.data.candidat.candidatures[1].statut_name)
        setSelectMastere2(
          resMastere.data.candidat.candidatures[1].specialite_master
        )
        setCandidature1(resMastere.data.candidat.candidatures[1].id)
        const matieres1 = resMastere.data.candidat.candidatures[1].matieres
        setArrayMatiere2(matieres1)
        const choixInit2 = {}
        const notesInit2 = {}
        matieres1.forEach(m => {
          if (m.note && m.note !== "" && m.note !== null) {
            choixInit2[m.value] = "oui"
            notesInit2[m.value] = m.note
          } else {
            choixInit2[m.value] = "non"
          }
        })
        setChoixMatieres2(choixInit2)
        setNotesMatieres2(notesInit2)
      }
    })
    API.post("master/specialite_master/select", {
      annee_id: annee_id,
    }).then(resMaster => {
      setMastere1(resMaster.data.Specialites)
      setMastere2(resMaster.data.Specialites)
    })
    API.get("master/nature_licence/select").then(resNature => {
      setNatureLicence(resNature.data.NatureLicences)
    })
    API.get("master/etablissement_origine/select").then(resEtablissement => {
      setEtablissementOrigine(resEtablissement.data.Etablissement)
    })
    API.get("session/select").then(resSession1 => {
      setSessionLicence1(resSession1.data.Session)
      setSessionLicence2(resSession1.data.Session)
      setSessionLicence3(resSession1.data.Session)
    })
  }, [])
  const save = async () => {
    // --- VALIDATION DYNAMIQUE DES CHAMPS ---
    const validations = [
      { field: prenom, message: "⛔ Prénom obligatoire !!" },
      { field: nom, message: "⛔ Nom obligatoire !!" },
      { field: cin, message: "⛔ CIN obligatoire !!" },
      { field: email, message: "⛔ Email obligatoire !!" },
      { field: telephone, message: "⛔ Téléphone obligatoire !!" },
      {
        field: selectNatureLicence,
        message: "⛔ Nature de licence obligatoire !!",
      },
      { field: anneeLicence, message: "⛔ Année licence obligatoire !!" },
      {
        field: moyGenAnnee1,
        message: "⛔ Moyenne générale de la première année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la première année doit être ≥ 0",
        errorMax: "La Moyenne générale de la première année doit être ≤ 20",
      },
      {
        field: moyGenAnnee2,
        message: "⛔ Moyenne générale de la deuxième année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la deuxième année doit être ≥ 0",
        errorMax: "La Moyenne générale de la deuxième année doit être ≤ 20",
      },
      {
        field: moyGenAnnee3,
        message: "⛔ Moyenne générale de la troisième année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la troisième année doit être ≥ 0",
        errorMax: "La Moyenne générale de la troisième année doit être ≤ 20",
      },
      {
        field: selectSessionLicence1,
        message: "⛔ Session d'admission obligatoire !!",
      },
      {
        field: selectSessionLicence2,
        message: "⛔ Session d'admission obligatoire !!",
      },
      {
        field: selectSessionLicence3,
        message: "⛔ Session d'admission obligatoire !!",
      },
      {
        field: credit1,
        message: "⛔ Crédit de la première année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "La Crédit de la première année doit être ≥ 0",
        errorMax: "La Crédit de la première année doit être ≤ 60",
      },
      {
        field: credit2,
        message: "⛔ Crédit de la deuxième année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "La Crédit de la deuxième année doit être ≥ 0",
        errorMax: "La Crédit de la deuxième année doit être ≤ 60",
      },
      {
        field: credit3,
        message: "⛔ Crédit de la troisième année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "La Crédit de la troisième année doit être ≥ 0",
        errorMax: "La Crédit de la troisième année doit être ≤ 60",
      },
      {
        field: notePFE,
        message: "⛔ Note du projet de fin d'étude (PFE) obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Note du projet de fin d'étude (PFE) doit être ≥ 0",
        errorMax: "La Note du projet de fin d'étude (PFE) doit être ≤ 20",
      },
      { field: selectMastere1, message: "⛔ Choix de mastère obligatoire !!" },
    ]

    const validateFields = () => {
      for (let v of validations) {
        if (!v.field || v.field === "") {
          setDisbutReg(true)
          toast.error(v.message, { containerId: "A" })
          return false // La validation échoue si un champ est vide
        }

        // Validation min/max pour les moyennes
        if (v.min !== undefined && v.max !== undefined) {
          if (v.field < v.min) {
            setDisbutReg(true)
            toast.error(v.errorMin || "Valeur trop faible", {
              containerId: "A",
            })
            return false
          }
          if (v.field > v.max) {
            setDisbutReg(true)
            toast.error(v.errorMax || "Valeur trop élevée", {
              containerId: "A",
            })
            return false
          }
        }
      }
      return true // Retourne true si toutes les validations passent
    }
    if (!selectEtablissementOrigine || selectEtablissementOrigine === "") {
      toast.error("⛔ Établissement d'origine obligatoire !!", {
        containerId: "A",
      })
      return
    }
    if (selectEtablissementOrigine.value == 3) {
      if (!selectSpecilaite || selectSpecilaite === "") {
        toast.error(
          "⛔ Spécialité de diplômes obtenus et parcours universitaire obligatoire !!",
          { containerId: "A" }
        )
        return
      }
    } else {
      if (!specilaiteName || specilaiteName === "") {
        toast.error(
          "⛔ Spécialité de diplômes obtenus et parcours universitaire obligatoire !!",
          { containerId: "A" }
        )
        return
      }
    }
    if (
      selectEtablissementOrigine.value === "autre" &&
      etablissementName === ""
    ) {
      toast.error("⛔ Nom de l'établissement d'origine obligatoire !!", {
        containerId: "A",
      })
      return
    }
    if (!releveLicence1)
      return toast.error("⛔ Relevé de licence 1 est obligatoire !")
    if (!releveLicence2)
      return toast.error("⛔ Relevé de licence 2 est obligatoire !")
    if (!releveLicence3)
      return toast.error("⛔ Relevé de licence 3 est obligatoire !")
    if (!diplomeLicence)
      return toast.error("⛔ Le diplôme de licence est obligatoire !")
    if (selectMastere1 && selectMastere1.value) {
      const countOuiMaster = Object.values(choixMatieres1).filter(
        v => v === "oui"
      ).length
      if (countOuiMaster < 3) {
        toast.error(
          "⛔ Spécialité Master, vous devez choisir au moins 3 matières !",
          { containerId: "A" }
        )
        return
      }
      for (let matiere of arrayMatiere1) {
        if (choixMatieres1[matiere.value] === "oui") {
          if (
            !notesMatieres1[matiere.value] ||
            notesMatieres1[matiere.value] === ""
          ) {
            toast.error(
              `⛔ La note pour la matière ${matiere.label} est obligatoire !`,
              { containerId: "A" }
            )
            return
          }
          if (
            notesMatieres1[matiere.value] < 0 ||
            notesMatieres1[matiere.value] > 20
          ) {
            toast.error(
              `⛔ La note pour la matière ${matiere.label} doit être entre 0 et 20 !`,
              { containerId: "A" }
            )
            return
          }
        }
      }
    }
    const isValid = validateFields()
    if (!isValid) return
    const formData = new FormData()
    formData.append("id", id)
    formData.append("nom_fr", nom)
    formData.append("prenom_fr", prenom)
    formData.append("email", email)
    formData.append("cin", cin)
    formData.append("telephone", telephone)
    formData.append(
      "etablissement_origine_id",
      selectEtablissementOrigine.value ?? null
    )
    formData.append("etablissement_name", etablissementName)
    formData.append("nature_licence_id", selectNatureLicence.value ?? null)
    formData.append("specialite_id", selectSpecilaite.value ?? null)
    formData.append("specialite_name", specilaiteName)
    formData.append("annee_licence", anneeLicence)
    formData.append("note_pfe", notePFE)
    formData.append("nb_annees_redoublement", anneeRedoublement)
    formData.append("moyenne_gen1", moyGenAnnee1)
    formData.append("moyenne_gen2", moyGenAnnee2)
    formData.append("moyenne_gen3", moyGenAnnee3)
    formData.append("session_licence1_id", selectSessionLicence1.value ?? null)
    formData.append("session_licence2_id", selectSessionLicence2.value ?? null)
    formData.append("session_licence3_id", selectSessionLicence3.value ?? null)
    formData.append("credit1", credit1)
    formData.append("credit2", credit2)
    formData.append("credit3", credit3)
    formData.append("annee_id", annee_id)
    const candidature1 = buildCandidature(
      selectMastere1,
      choixMatieres1,
      notesMatieres1
    )
    const candidature2 = buildCandidature(
      selectMastere2,
      choixMatieres2,
      notesMatieres2
    )
    let candidatures = []
    if (candidature1) candidatures.push(candidature1)
    if (candidature2) candidatures.push(candidature2)

    formData.append("candidatures", JSON.stringify(candidatures))

    formData.append("interne", selectEtablissementOrigine.value === 3 ? 1 : 0)

    formData.append("releve_licence_1", releveLicence1)
    formData.append("releve_licence_2", releveLicence2)
    formData.append("releve_licence_3", releveLicence3)
    formData.append("diplome_licence", diplomeLicence)
    formData.append("photo", photo)
    formData.append("user_id", user_id)
    const res = await API.post("/master/candidat/edit", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        annee: annee_id,
      },
    })
    switch (res.data.errNum) {
      case 200:
      case "200":
        toast.success("✔️" + res.data.msg, { containerId: "A" })
        props.history.push("/Candidat")
        break
      case 421:
      case "421":
      case 422:
      case "422":
      case 423:
      case "423":
      case 424:
      case "424":
        toast.error("⛔ " + res.data.msg, { containerId: "A" })
        break
      default:
        toast.error("⛔ " + res.data.msg, { containerId: "A" })
    }
  }
  const optionsAvecAutre = [
    ...etablissementOrigine,
    { label: "Autre", value: "autre" },
  ]
  const getSpec = async event => {
    setSelectSpecilaite("")
    setSpecilaiteName("")
    setSelectEtablissementOrigine(event)
    if (event.value == 3) {
      const res = await API.get("master/select_specialite").then(res => {
        setSpecialite(res.data.SpecialiteLicence)
      })
    }
  }

  const getMatiereMastere1 = async event => {
    setSelectMastere1(event)

    const res = await API.post("master/get_master_matieres_by_specialite", {
      annee_id: annee_id,
      specialite_master_id: event.value,
    })

    const matieres = res.data.matieres

    setArrayMatiere1(matieres)

    // Initialiser oui/non à null ou "non"
    const initialChoices1 = {}
    matieres.forEach(m => {
      initialChoices1[m.value] = null // ou false
    })
    setChoixMatieres1(initialChoices1)
  }
  const handleChoice1 = (matiereId, value) => {
    setChoixMatieres1(prev => ({
      ...prev,
      [matiereId]: value,
    }))
    if (value === "non") {
      setNotesMatieres1(prev => {
        const newNotes = { ...prev }
        delete newNotes[matiereId]
        return newNotes
      })
    }
  }
  const getMatiereMastere2 = async event => {
    setSelectMastere2(event)

    const res = await API.post("master/get_master_matieres_by_specialite", {
      annee_id: annee_id,
      specialite_master_id: event.value,
    })

    const matieres = res.data.matieres

    setArrayMatiere2(matieres)

    // Initialiser oui/non à null ou "non"
    const initialChoices2 = {}
    matieres.forEach(m => {
      initialChoices2[m.value] = null // ou false
    })
    setChoixMatieres2(initialChoices2)
  }
  const handleChoice2 = (matiereValue, choice) => {
    setChoixMatieres2(prev => ({
      ...prev,
      [matiereValue]: choice,
    }))
    if (choice === "non") {
      setNotesMatieres2(prev => {
        const newNotes = { ...prev }
        delete newNotes[matiereValue]
        return newNotes
      })
    }
  }
  const handleNoteChange1 = (matiereId, value) => {
    setNotesMatieres1(prev => ({
      ...prev,
      [matiereId]: value,
    }))
  }
  const handleNoteChange2 = (matiereId, value) => {
    setNotesMatieres2(prev => ({
      ...prev,
      [matiereId]: value,
    }))
  }
  const buildCandidature = (specialite, choixMatieres, notesMatieres) => {
    if (!specialite) return null // master non sélectionné

    const matieres = Object.keys(choixMatieres)
      .filter(matiereId => choixMatieres[matiereId] === "oui") // garder seulement les OUI
      .map(matiereId => ({
        id: Number(matiereId),
        note: Number(notesMatieres[matiereId] || 0),
      }))

    return {
      specialite_master_id: specialite.value,
      priorite: specialite === selectMastere1 ? 1 : 0,
      matieres,
    }
  }
  const addReleveLicence1 = e => {
    var file = e.target.files[0]
    setReleveLicence1(file)
  }
  const addReleveLicence2 = e => {
    var file = e.target.files[0]
    setReleveLicence2(file)
  }
  const addReleveLicence3 = e => {
    var file = e.target.files[0]
    setReleveLicence3(file)
  }
  const addReleveDiplome = e => {
    var file = e.target.files[0]
    setDiplomeLicence(file)
  }
  const addPhoto = e => {
    var file = e.target.files[0]
    setPhoto(file)
  }
  // eslint-disable-next-line react/prop-types
  const FileField = ({ label, onChange, file }) => {
    return (
      <div className="mb-3">
        <Label>{label}</Label>
        <Input
          onChange={onChange}
          className="form-control"
          type="file"
          accept="application/pdf"
        />

        {/* Si fichier existe, afficher lien */}
        {file && (
          <div className="mt-2">
            <a
              // href={file}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => download(file)}
              style={{ color: "#3ba897", fontWeight: "bold" }}
            >
              <i
                style={{
                  color: "#3ba897",
                  cursor: "pointer",
                  fontSize: "15px",
                  margin: "0px 6px 0px 0px",
                }}
                className="fas fa-file-pdf"
              ></i>{" "}
              Télécharger le fichier existant
            </a>
          </div>
        )}
      </div>
    )
  }
  const download = file => {
    var url = window.location.href
    var array = url.split("=")
    var CandidatCin = array[1]
    API.post(
      "master/candidat/download",
      {
        cin: CandidatCin,
        annee_id: annee_id,
        filename: file,
      },
      { responseType: "blob" }
    )
      .then(res => {
        if (res.data instanceof Blob) {
          const blob = res.data
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          const contentDisposition = res.headers["content-disposition"]
          let filename = `${name || "document"}.pdf`
          if (contentDisposition) {
            const matches = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            )
            if (matches && matches[1]) {
              filename = matches[1].replace(/['"]/g, "")
            }
          }
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        } else {
          if (res.data.errNum === 404 || res.data.errNum === "404") {
            toast.error("⛔ " + res.data.msg, { containerId: "A" })
          } else {
            toast.error("Erreur inconnue lors du téléchargement.", {
              containerId: "A",
            })
          }
        }
      })
      .catch(err => {
        console.error("Erreur lors de la requête :", err)
        toast.error("Erreur de téléchargement. Vérifiez votre connexion.", {
          containerId: "A",
        })
      })
  }
  const toggle = id => {
    setModal(!modal)
  }
  const toggle1 = id => {
    setModal1(!modal1)
  }
  const valider = () => {
    var url = window.location.href
    var array = url.split("=")
    var CandidatCin = array[1]
    API.post("master/candidat/update_statut", {
      id: candidature,
      annee_id: annee_id,
      user_id: user_id,
      statut_id: selectStatus.value,
    }).then(res => {
      toast.success(" Votre status a été modifier avec succès", {
        containerId: "A",
      })
      setModal(false)
      setSelectStatus("")
      API.post("master/candidat/get_by_cin", {
        annee_id: annee_id,
        cin: CandidatCin,
      }).then(resMastere => {
        setId(resMastere.data.candidat.id)
        setNom(resMastere.data.candidat.nom_fr)
        setPrenom(resMastere.data.candidat.prenom_fr)
        setCin(resMastere.data.candidat.cin)
        setEmail(resMastere.data.candidat.email)
        setTelephone(resMastere.data.candidat.telephone)
        setSelectNatureLicence(resMastere.data.candidat.nature_licence)
        setSelectEtablissementOrigine(resMastere.data.candidat.etablissement)
        setEtablissementName(resMastere.data.candidat.etablissement_name)
        setAnneeLicence(resMastere.data.candidat.annee_licence)
        setSelectSpecilaite(resMastere.data.candidat.specialite)
        setSpecilaiteName(resMastere.data.candidat.specialite_name)
        setMoyGenAnnee1(
          resMastere.data.candidat.moyennes_generales.moyenne_gen1
        )
        setMoyGenAnnee2(
          resMastere.data.candidat.moyennes_generales.moyenne_gen2
        )
        setMoyGenAnnee3(
          resMastere.data.candidat.moyennes_generales.moyenne_gen3
        )
        setCredit1(resMastere.data.candidat.credits.credit1)
        setCredit2(resMastere.data.candidat.credits.credit2)
        setCredit3(resMastere.data.candidat.credits.credit3)
        setCredit3(resMastere.data.candidat.credits.credit3)
        setSelectSessionLicence1(
          resMastere.data.candidat.sessions_licence.session_licence1
        )
        setSelectSessionLicence2(
          resMastere.data.candidat.sessions_licence.session_licence2
        )
        setSelectSessionLicence3(
          resMastere.data.candidat.sessions_licence.session_licence3
        )
        setNotePFE(resMastere.data.candidat.note_pfe)
        setAnneeRedoublement(resMastere.data.candidat.nb_annees_redoublement)
        setReleveLicence1(resMastere.data.candidat.releve_licence_1 ?? null)
        setReleveLicence2(resMastere.data.candidat.releve_licence_2 ?? null)
        setReleveLicence3(resMastere.data.candidat.releve_licence_3 ?? null)
        setDiplomeLicence(resMastere.data.candidat.diplome_licence ?? null)
        setPhoto(resMastere.data.candidat.photo ?? null)
        setScore(resMastere.data.candidat.candidatures[0].score)
        setEtatValide(resMastere.data.candidat.candidatures[0].statut_id)
        setStatusName(resMastere.data.candidat.candidatures[0].statut_name)
        setCandidature(resMastere.data.candidat.candidatures[0].id)
        if (resMastere.data.candidat.photo != null) {
          API.post(
            "master/candidat/download",
            {
              cin: CandidatCin,
              annee_id: annee_id,
              filename: resMastere.data.candidat.photo,
            },
            { responseType: "blob" }
          )
            .then(resPhoto => {
              if (resPhoto.data instanceof Blob) {
                const blob = resPhoto.data
                const url = window.URL.createObjectURL(blob)
                setPhotoUrl(url)
              } else {
                if (res.data.errNum === 404 || res.data.errNum === "404") {
                  toast.error(":no_entry: " + res.data.msg, {
                    containerId: "A",
                  })
                } else {
                  toast.error(
                    "Erreur inconnue lors du chargement de la photo.",
                    {
                      containerId: "A",
                    }
                  )
                }
              }
            })
            .catch(err => {
              toast.error("Erreur de chargement. Vérifiez votre connexion.", {
                containerId: "A",
              })
            })
        }
        setSelectMastere1(
          resMastere.data.candidat.candidatures[0].specialite_master
        )
        const matieres = resMastere.data.candidat.candidatures[0].matieres
        setArrayMatiere1(matieres)
        const choixInit = {}
        const notesInit = {}
        matieres.forEach(m => {
          if (m.note && m.note !== "" && m.note !== null) {
            choixInit[m.value] = "oui"
            notesInit[m.value] = m.note
          } else {
            choixInit[m.value] = "non"
          }
        })
        setChoixMatieres1(choixInit)
        setNotesMatieres1(notesInit)
        if (resMastere.data.candidat.candidatures[1]) {
          setEtatValide1(resMastere.data.candidat.candidatures[1].statut_id)
          setScore1(resMastere.data.candidat.candidatures[1].score)
          setSelectMastere2(
            resMastere.data.candidat.candidatures[1].specialite_master
          )
          setStatusName1(resMastere.data.candidat.candidatures[1].statut_name)
          setCandidature1(resMastere.data.candidat.candidatures[1].id)
          const matieres1 = resMastere.data.candidat.candidatures[1].matieres
          setArrayMatiere2(matieres1)
          const choixInit2 = {}
          const notesInit2 = {}
          matieres1.forEach(m => {
            if (m.note && m.note !== "" && m.note !== null) {
              choixInit2[m.value] = "oui"
              notesInit2[m.value] = m.note
            } else {
              choixInit2[m.value] = "non"
            }
          })
          setChoixMatieres2(choixInit2)
          setNotesMatieres2(notesInit2)
        }
      })
    })
  }
  const valider1 = () => {
    var url = window.location.href
    var array = url.split("=")
    var CandidatCin = array[1]
    API.post("master/candidat/update_statut", {
      id: candidature1,
      annee_id: annee_id,
      user_id: user_id,
      statut_id: selectStatus.value,
    }).then(res => {
      toast.success(" Votre status a été modifier avec succès", {
        containerId: "A",
      })
      setModal1(false)
      setSelectStatus("")
      API.post("master/candidat/get_by_cin", {
        annee_id: annee_id,
        cin: CandidatCin,
      }).then(resMastere => {
        setId(resMastere.data.candidat.id)
        setNom(resMastere.data.candidat.nom_fr)
        setPrenom(resMastere.data.candidat.prenom_fr)
        setCin(resMastere.data.candidat.cin)
        setEmail(resMastere.data.candidat.email)
        setTelephone(resMastere.data.candidat.telephone)
        setSelectNatureLicence(resMastere.data.candidat.nature_licence)
        setSelectEtablissementOrigine(resMastere.data.candidat.etablissement)
        setEtablissementName(resMastere.data.candidat.etablissement_name)
        setAnneeLicence(resMastere.data.candidat.annee_licence)
        setSelectSpecilaite(resMastere.data.candidat.specialite)
        setSpecilaiteName(resMastere.data.candidat.specialite_name)
        setMoyGenAnnee1(
          resMastere.data.candidat.moyennes_generales.moyenne_gen1
        )
        setMoyGenAnnee2(
          resMastere.data.candidat.moyennes_generales.moyenne_gen2
        )
        setMoyGenAnnee3(
          resMastere.data.candidat.moyennes_generales.moyenne_gen3
        )
        setCredit1(resMastere.data.candidat.credits.credit1)
        setCredit2(resMastere.data.candidat.credits.credit2)
        setCredit3(resMastere.data.candidat.credits.credit3)
        setCredit3(resMastere.data.candidat.credits.credit3)
        setSelectSessionLicence1(
          resMastere.data.candidat.sessions_licence.session_licence1
        )
        setSelectSessionLicence2(
          resMastere.data.candidat.sessions_licence.session_licence2
        )
        setSelectSessionLicence3(
          resMastere.data.candidat.sessions_licence.session_licence3
        )
        setNotePFE(resMastere.data.candidat.note_pfe)
        setAnneeRedoublement(resMastere.data.candidat.nb_annees_redoublement)
        setReleveLicence1(resMastere.data.candidat.releve_licence_1 ?? null)
        setReleveLicence2(resMastere.data.candidat.releve_licence_2 ?? null)
        setReleveLicence3(resMastere.data.candidat.releve_licence_3 ?? null)
        setDiplomeLicence(resMastere.data.candidat.diplome_licence ?? null)
        setPhoto(resMastere.data.candidat.photo ?? null)
        setScore(resMastere.data.candidat.candidatures[0].score)
        setEtatValide(resMastere.data.candidat.candidatures[0].statut_id)
        setStatusName(resMastere.data.candidat.candidatures[0].statut_name)
        setCandidature(resMastere.data.candidat.candidatures[0].id)
        if (resMastere.data.candidat.photo != null) {
          API.post(
            "master/candidat/download",
            {
              cin: CandidatCin,
              annee_id: annee_id,
              filename: resMastere.data.candidat.photo,
            },
            { responseType: "blob" }
          )
            .then(resPhoto => {
              if (resPhoto.data instanceof Blob) {
                const blob = resPhoto.data
                const url = window.URL.createObjectURL(blob)
                setPhotoUrl(url)
              } else {
                if (res.data.errNum === 404 || res.data.errNum === "404") {
                  toast.error(":no_entry: " + res.data.msg, {
                    containerId: "A",
                  })
                } else {
                  toast.error(
                    "Erreur inconnue lors du chargement de la photo.",
                    {
                      containerId: "A",
                    }
                  )
                }
              }
            })
            .catch(err => {
              toast.error("Erreur de chargement. Vérifiez votre connexion.", {
                containerId: "A",
              })
            })
        }
        setSelectMastere1(
          resMastere.data.candidat.candidatures[0].specialite_master
        )
        const matieres = resMastere.data.candidat.candidatures[0].matieres
        setArrayMatiere1(matieres)
        const choixInit = {}
        const notesInit = {}
        matieres.forEach(m => {
          if (m.note && m.note !== "" && m.note !== null) {
            choixInit[m.value] = "oui"
            notesInit[m.value] = m.note
          } else {
            choixInit[m.value] = "non"
          }
        })
        setChoixMatieres1(choixInit)
        setNotesMatieres1(notesInit)
        if (resMastere.data.candidat.candidatures[1]) {
          setEtatValide1(resMastere.data.candidat.candidatures[1].statut_id)
          setScore1(resMastere.data.candidat.candidatures[1].score)
          setSelectMastere2(
            resMastere.data.candidat.candidatures[1].specialite_master
          )
          setStatusName1(resMastere.data.candidat.candidatures[1].statut_name)
          setCandidature1(resMastere.data.candidat.candidatures[1].id)
          const matieres1 = resMastere.data.candidat.candidatures[1].matieres
          setArrayMatiere2(matieres1)
          const choixInit2 = {}
          const notesInit2 = {}
          matieres1.forEach(m => {
            if (m.note && m.note !== "" && m.note !== null) {
              choixInit2[m.value] = "oui"
              notesInit2[m.value] = m.note
            } else {
              choixInit2[m.value] = "non"
            }
          })
          setChoixMatieres2(choixInit2)
          setNotesMatieres2(notesInit2)
        }
      })
    })
  }
  const buttonColor =
    etatValide === 1
      ? "warning"
      : etatValide === 2
      ? "info"
      : etatValide === 3
      ? "success"
      : etatValide === 4
      ? "danger"
      : "secondary"
  const buttonColor1 =
    etatValide1 === 1
      ? "warning"
      : etatValide1 === 2
      ? "info"
      : etatValide1 === 3
      ? "success"
      : etatValide1 === 4
      ? "danger"
      : "secondary"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <AvForm className="form-horizontal">
                  <Row>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Prénom :</Label>
                        <AvField
                          name="prenom"
                          placeholder="Entrer Prénom"
                          type="text"
                          errorMessage="* Prénom obligatoire"
                          className="form-control "
                          value={prenom}
                          validate={{ required: { value: true } }}
                          onChange={e => setPrenom(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Nom de la famille :
                        </Label>
                        <AvField
                          name="nom"
                          placeholder="Entrer Nom"
                          type="text"
                          errorMessage="* Nom obligatoire"
                          className="form-control "
                          value={nom}
                          validate={{ required: { value: true } }}
                          onChange={e => setNom(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">CIN :</Label>
                        <AvField
                          name="CIN"
                          placeholder="Entrer CIN"
                          type="text"
                          errorMessage="* CIN obligatoire"
                          className="form-control "
                          value={cin}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "* CIN obligatoire",
                            },
                            pattern: {
                              // ✅ regex correcte
                              value: /^[0-9]{8}$/,
                              errorMessage:
                                "Le CIN doit contenir exactement 8 chiffres",
                            },
                          }}
                          onChange={e => setCin(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Email :</Label>
                        <AvField
                          name="Email"
                          placeholder="Entrer Email"
                          type="email"
                          errorMessage="* Email obligatoire"
                          className="form-control "
                          value={email}
                          validate={{ required: { value: true } }}
                          onChange={e => setEmail(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Numéro de téléphone :
                        </Label>
                        <AvField
                          name="telephone"
                          placeholder="Entrer Numéro de téléphone"
                          type="text" // ⚠️ changer "tel" en "text"
                          className="form-control"
                          value={telephone}
                          onChange={e => setTelephone(e.target.value)}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "* Numéro de téléphone obligatoire",
                            },
                            pattern: {
                              // ✅ regex correcte
                              value: /^[0-9]{8}$/,
                              errorMessage:
                                "Le numéro doit contenir exactement 8 chiffres",
                            },
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Photo :</Label>
                        <Input
                          onChange={e => addPhoto(e)}
                          className="form-control"
                          type="file"
                          id="formFile"
                          accept="image/png, image/jpeg, image/jpg"
                        />
                      </div>
                    </Col>
                    {photo != null ? (
                      <Col lg="12">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1"></Label>
                          <img
                            src={photoUrl}
                            alt="Photo du candidat"
                            style={{ maxWidth: "200px", maxHeight: "200px" }} // Ajustez pour la taille
                          />
                        </div>
                      </Col>
                    ) : null}
                  </Row>
                  <CardTitle
                    style={{ color: "#556ee6" }}
                    className="h4 mb-4 mt-4"
                  >
                    Diplômes obtenus et parcours universitaire :
                  </CardTitle>
                  <Row>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Nature de la licence :
                        </Label>
                        <Select
                          options={natureLicence}
                          isSearchable={true}
                          value={selectNatureLicence}
                          onChange={e => setSelectNatureLicence(e)}
                        />
                      </div>
                    </Col>
                    <Col
                      lg={
                        selectEtablissementOrigine?.value === "autre"
                          ? "4"
                          : "4"
                      }
                    >
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Etablissement d'origine"} :
                        </Label>
                        <Select
                          options={optionsAvecAutre}
                          isSearchable={true}
                          value={selectEtablissementOrigine}
                          onChange={e => getSpec(e)}
                        />
                      </div>
                    </Col>
                    {selectEtablissementOrigine?.value === "autre" && (
                      <Col lg="4">
                        <Label for="basicpill-firstname-input1">
                          {"Nom établissement d'origine "}
                        </Label>
                        <AvField
                          name="Etablissement"
                          placeholder="Entrer Etablissement d'origine"
                          type="text"
                          errorMessage="* Etablissement d'origine obligatoire"
                          className="form-control"
                          value={etablissementName}
                          validate={{ required: { value: true } }}
                          onChange={e => setEtablissementName(e.target.value)}
                        />
                      </Col>
                    )}
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Année d'obtention du diplôme de licence :"}
                        </Label>
                        <AvField
                          name="anneeObtentionLicence"
                          placeholder="Entrer Année d'obtention du diplôme de licence "
                          type="text"
                          errorMessage="* Année d'obtention du diplôme de licence obligatoire"
                          className="form-control "
                          validate={{ required: { value: true } }}
                          value={anneeLicence}
                          onChange={e => setAnneeLicence(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Spécilaité :"}
                        </Label>
                        {selectEtablissementOrigine?.value === 3 ? (
                          <Select
                            options={specialite}
                            isSearchable={true}
                            value={selectSpecilaite}
                            onChange={e => setSelectSpecilaite(e)}
                          />
                        ) : (
                          <AvField
                            name="specilaite"
                            placeholder="Entrer Spécilaité "
                            type="text"
                            errorMessage="* Spécilaité obligatoire"
                            className="form-control "
                            value={specilaiteName}
                            validate={{ required: { value: true } }}
                            onChange={e => setSpecilaiteName(e.target.value)}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                  <CardTitle
                    style={{ color: "#556ee6" }}
                    className="h4 mb-4 mt-4"
                  >
                    Eléments du calcul de score :
                  </CardTitle>
                  <Row>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Moyenne générale de la première année :
                        </Label>
                        <AvField
                          name="Moyenne générale de la première année"
                          placeholder="Entrer Moyenne générale de la première année"
                          type="number"
                          errorMessage="* Moyenne générale de la première année obligatoire"
                          className="form-control "
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 20,
                              errorMessage: "La moyenne doit être ≤ 20",
                            },
                          }}
                          value={moyGenAnnee1}
                          onChange={e => setMoyGenAnnee1(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Crédit de la première année :
                        </Label>
                        <AvField
                          name="Crédit de la première année"
                          placeholder="Entrer Crédit de la première année"
                          type="number"
                          errorMessage="* Crédit de la première année obligatoire"
                          className="form-control "
                          value={credit1}
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La Crédit doit être ≥ 0",
                            },
                            max: {
                              value: 60,
                              errorMessage: "La Crédit doit être ≤ 60",
                            },
                          }}
                          onChange={e => setCredit1(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Session d'admission :"}
                        </Label>
                        <Select
                          options={sessionLicence1}
                          isSearchable={true}
                          value={selectSessionLicence1}
                          onChange={e => setSelectSessionLicence1(e)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Moyenne générale de la deuxième année :
                        </Label>
                        <AvField
                          name="Moyenne générale de la deuxième année"
                          placeholder="Entrer Moyenne générale de la deuxième année"
                          type="number"
                          errorMessage="* Moyenne générale de la deuxième année obligatoire"
                          className="form-control "
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 20,
                              errorMessage: "La moyenne doit être ≤ 20",
                            },
                          }}
                          value={moyGenAnnee2}
                          onChange={e => setMoyGenAnnee2(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Crédit de la deuxième année :
                        </Label>
                        <AvField
                          name="Crédit de la deuxième année"
                          placeholder="Entrer Crédit de la deuxième année"
                          type="number"
                          errorMessage="* Crédit de la deuxième année obligatoire"
                          className="form-control "
                          value={credit2}
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 60,
                              errorMessage: "La moyenne doit être ≤ 60",
                            },
                          }}
                          onChange={e => setCredit2(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Session d'admission :"}
                        </Label>
                        <Select
                          options={sessionLicence2}
                          isSearchable={true}
                          value={selectSessionLicence2}
                          onChange={e => setSelectSessionLicence2(e)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Moyenne générale de la troisième année :
                        </Label>
                        <AvField
                          name="Moyenne générale de la troisième année"
                          placeholder="Entrer Moyenne générale de la troisième année"
                          type="number"
                          errorMessage="* Moyenne générale de la troisième année obligatoire"
                          className="form-control "
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 20,
                              errorMessage: "La moyenne doit être ≤ 20",
                            },
                          }}
                          value={moyGenAnnee3}
                          onChange={e => setMoyGenAnnee3(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Crédit de la troisième année :
                        </Label>
                        <AvField
                          name="Crédit de la troisième année"
                          placeholder="Entrer Crédit de la troisième année"
                          type="number"
                          errorMessage="* Crédit de la troisième année obligatoire"
                          className="form-control "
                          value={credit3}
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 60,
                              errorMessage: "La moyenne doit être ≤ 60",
                            },
                          }}
                          onChange={e => setCredit3(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col lg="4">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Session d'admission :"}
                        </Label>
                        <Select
                          options={sessionLicence3}
                          isSearchable={true}
                          value={selectSessionLicence3}
                          onChange={e => setSelectSessionLicence3(e)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <CardTitle
                      style={{ color: "#ff0000" }}
                      className="h4 mb-4 mt-4"
                    >
                      {
                        "Uniquement les candidats titulaires d'une licence appelés à saisir la note du PFE. Pour les autres candidats(licences fondamentales et nationales) veuillez saisir zéro et votre score ne sera pas affecté. "
                      }
                    </CardTitle>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Note du projet de fin d'étude (PFE) :"}
                        </Label>
                        <AvField
                          name="Note du projet de fin d'étude (PFE)"
                          placeholder="Entrer Note du projet de fin d'étude (PFE)"
                          type="number"
                          errorMessage="* Note du projet de fin d'étude (PFE) obligatoire"
                          className="form-control "
                          value={notePFE}
                          validate={{
                            required: { value: true },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 20,
                              errorMessage: "La moyenne doit être ≤ 20",
                            },
                          }}
                          onChange={e => setNotePFE(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Nombre d'année de redoublement :"}
                        </Label>
                        <AvField
                          name="Nombre d'année de redoublement"
                          placeholder="Entrer Nombre d'année de redoublement"
                          type="number"
                          errorMessage="* Nombre d'année de redoublement obligatoire"
                          className="form-control"
                          value={anneeRedoublement}
                          validate={{
                            required: {
                              value: true,
                              errorMessage:
                                "* Nombre d'année de redoublement obligatoire",
                            },
                            min: {
                              value: 0,
                              errorMessage: "La moyenne doit être ≥ 0",
                            },
                            max: {
                              value: 20,
                              errorMessage: "La moyenne doit être ≤ 20",
                            },
                          }}
                          onChange={e => setAnneeRedoublement(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <CardTitle
                    style={{ color: "#556ee6" }}
                    className="h4 mb-4 mt-4"
                  >
                    Les relevées de licences :
                  </CardTitle>
                  <Row>
                    <Col lg="3">
                      <FileField
                        label="Relevée de licence 1ère année :"
                        onChange={addReleveLicence1}
                        file={releveLicence1}
                      />
                    </Col>

                    <Col lg="3">
                      <FileField
                        label="Relevée de licence 2ème année :"
                        onChange={addReleveLicence2}
                        file={releveLicence2}
                      />
                    </Col>

                    <Col lg="3">
                      <FileField
                        label="Relevée de licence 3ème année :"
                        onChange={addReleveLicence3}
                        file={releveLicence3}
                      />
                    </Col>

                    <Col lg="3">
                      <FileField
                        label="Relevée de diplôme :"
                        onChange={addReleveDiplome}
                        file={diplomeLicence}
                      />
                    </Col>
                  </Row>
                  <CardTitle
                    style={{ color: "#556ee6" }}
                    className="h4 mb-4 mt-4"
                  >
                    Choix de masrères :
                  </CardTitle>

                  <Row>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Mastère :"}
                        </Label>
                        <Select
                          options={mastere1}
                          isSearchable={true}
                          value={selectMastere1}
                          onChange={e => getMatiereMastere1(e)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Score Mastère  :"}
                        </Label>
                        <h3>{score}</h3>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="text-center mt-4"
                      >
                        {etatCandidature == 1 ?? (
                          <a
                            name="Confirmer"
                            type="button"
                            color={buttonColor}
                            className={`btn mb-2 me-2 btn-${buttonColor}`}
                            onClick={toggle}
                          >
                            Validation
                          </a>
                        )}
                      </div>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          color: "red",
                        }}
                      >
                        {statusName}
                      </p>
                    </Col>
                  </Row>
                  <h4> Matières fondamentales :</h4>
                  <Row>
                    <Col lg="6">
                      {arrayMatiere1.map((matiere, index) => (
                        <div
                          key={matiere.value}
                          className="mb-3 border p-2 rounded"
                        >
                          <h6>
                            {index + 1}. {matiere.label}
                          </h6>

                          {/* Radios Oui / Non */}
                          <div>
                            <label style={{ marginRight: "15px" }}>
                              <input
                                type="radio"
                                name={`matiere_${matiere.value}`}
                                value="oui"
                                checked={
                                  choixMatieres1[matiere.value] === "oui"
                                }
                                onChange={() =>
                                  handleChoice1(matiere.value, "oui")
                                }
                              />{" "}
                              Oui
                            </label>

                            <label>
                              <input
                                type="radio"
                                name={`matiere_${matiere.value}`}
                                value="non"
                                checked={
                                  choixMatieres1[matiere.value] === "non"
                                }
                                onChange={() =>
                                  handleChoice1(matiere.value, "non")
                                }
                              />{" "}
                              Non
                            </label>
                          </div>

                          {/* Input Note → s'affiche seulement si "oui" */}
                          {choixMatieres1[matiere.value] === "oui" && (
                            <div className="mt-2">
                              <AvField
                                name="Note / 20"
                                placeholder="Entrer Note / 20"
                                type="number"
                                errorMessage="* Note / 20 obligatoire"
                                className="form-control "
                                value={notesMatieres1[matiere.value] || ""}
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La note doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La note doit être ≤ 20",
                                  },
                                }}
                                onChange={e =>
                                  handleNoteChange1(
                                    matiere.value,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Mastère 2 (facultatif) :"}
                        </Label>
                        <Select
                          options={mastere2}
                          isSearchable={true}
                          value={selectMastere2}
                          onChange={e => getMatiereMastere2(e)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          {"Score Mastère 2  :"}
                        </Label>
                        <h3>{score1}</h3>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="text-center mt-4"
                      >
                        {etatCandidature == 1 ?? (
                          <a
                            name="Confirmer"
                            type="button"
                            color={buttonColor1}
                            className={`btn mb-2 me-2 btn-${buttonColor1}`}
                            onClick={toggle1}
                          >
                            Validation
                          </a>
                        )}
                      </div>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          color: "red",
                        }}
                      >
                        {statusName1}
                      </p>
                    </Col>
                  </Row>
                  <h4> Matières fondamentales :</h4>
                  <Row>
                    <Col lg="6">
                      {arrayMatiere2.map((matiere, index) => (
                        <div
                          key={matiere.value}
                          className="mb-3 border p-2 rounded"
                        >
                          <h6>
                            {index + 1}. {matiere.label}
                          </h6>
                          <div>
                            <label style={{ marginRight: "15px" }}>
                              <input
                                type="radio"
                                name={`matiere_${matiere.value}`}
                                value="oui"
                                checked={
                                  choixMatieres2[matiere.value] === "oui"
                                }
                                onChange={() =>
                                  handleChoice2(matiere.value, "oui")
                                }
                              />{" "}
                              Oui
                            </label>

                            <label>
                              <input
                                type="radio"
                                name={`matiere_${matiere.value}`}
                                value="non"
                                checked={
                                  choixMatieres2[matiere.value] === "non"
                                }
                                onChange={() =>
                                  handleChoice2(matiere.value, "non")
                                }
                              />{" "}
                              Non
                            </label>
                          </div>
                          {/* Input Note → s'affiche seulement si "oui" */}
                          {choixMatieres2[matiere.value] === "oui" && (
                            <div className="mt-2">
                              <AvField
                                name="Note / 20"
                                placeholder="Entrer Note / 20"
                                type="number"
                                errorMessage="* Note / 20 obligatoire"
                                className="form-control "
                                value={notesMatieres2[matiere.value] || ""}
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La note doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La note doit être ≤ 20",
                                  },
                                }}
                                onChange={e =>
                                  handleNoteChange2(
                                    matiere.value,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </Col>
                  </Row>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <Col
                      lg="12"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="button"
                        className="btn btn-warning mb-2 me-2"
                        onClick={() => props.history.push("/Candidat")}
                      >
                        Annuler
                      </Button>
                      {etatCandidature == 1 ? (
                        <Button
                          id="Confirmer"
                          name="Confirmer"
                          type="button"
                          color="primary"
                          className="btn btn-primary mb-2 me-2"
                          disabled={!disbutReg}
                          onClick={save}
                        >
                          Confirmer
                        </Button>
                      ) : null}
                    </Col>
                  </div>
                </AvForm>
              </Row>
            </CardBody>
          </Card>
          <ToastContainer
            transition={Flip}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {"Modification status d'inscription"}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">
              Statut de la candidature :
            </Label>
            <Select
              options={status}
              isSearchable={true}
              isClearable={true}
              value={selectStatus}
              onChange={e => setSelectStatus(e)}
            />
          </div>
          <div
            className="hvr-push"
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "15px",
            }}
          >
            <div>
              <Button color="info" className="btn-rounded " onClick={valider}>
                <i style={{ color: "white" }} className="far fa-thumbs-up"></i>
                OUI
              </Button>
            </div>
            <div>
              <Button onClick={toggle} color="danger" className="btn-rounded ">
                <i
                  style={{ color: "white" }}
                  className="far fa-thumbs-down"
                ></i>
                NON
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal1} toggle={toggle1} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle1}
          tag="h4"
        >
          {"Modification status d'inscription"}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">
              Statut de la candidature :
            </Label>
            <Select
              options={status}
              isSearchable={true}
              isClearable={true}
              value={selectStatus}
              onChange={e => setSelectStatus(e)}
            />
          </div>
          <div
            className="hvr-push"
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "15px",
            }}
          >
            <div>
              <Button color="info" className="btn-rounded " onClick={valider1}>
                <i style={{ color: "white" }} className="far fa-thumbs-up"></i>
                OUI
              </Button>
            </div>
            <div>
              <Button onClick={toggle1} color="danger" className="btn-rounded ">
                <i
                  style={{ color: "white" }}
                  className="far fa-thumbs-down"
                ></i>
                NON
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(ViewCandidat)

ViewCandidat.propTypes = {
  history: PropTypes.object,
}
